/**
 * Frontend feature flags
 */
export const featureFlags = {
  schemaBuilder: import.meta.env.VITE_ENABLE_SCHEMA_BUILDER === "true",
};
